import React from 'react';
import PropTypes from 'prop-types';

export const DocumentDirectory = ({ width , height , ...props }) => (
  <svg
    data-icon='document-directory'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M4 20c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 18V8c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 4 6h6l2-2h8c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 20H4Zm1.825-7H11V7.825L5.825 13ZM4 12l4-4H4v4Zm0 3v3h16V6h-7v7c0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 11 15H4Z'
    />
  </svg>
);

DocumentDirectory.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

DocumentDirectory.defaultProps = {
  width: 24,
  height: 24,
};
